import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformAdminGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(): any {
    return this.authService.user$.pipe(
      take(1),
      map((user) => {
        if (user?.isPlatformAdmin === true) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      })
    );
  }
}
